/* eslint-disable no-restricted-globals */
function workerCode() {
    
    let timer = 1800
    let timerRef: any = null
    let initialized = false

    self.onmessage = (ev: MessageEvent<any>) => {

        if (ev.data === 'terminate') {
            for (let i = 0 ; i < timerRef ; i++) {
                clearTimeout(i); 
            }
            console.log('worker terminated...')
            initialized = false
            timer = 1800
            postMessage('terminated')
            return
        }
        
        if (ev.data === 'reset') {
            for (let i = 0 ; i < timerRef ; i++) {
                clearTimeout(i); 
            }
            timer = 1800
        }

        if (ev.data === 'start') {   
            
            if(timerRef !== null) return

            initialized = true

            if (initialized) {
                postMessage('initialized')
            }

            timerRef = setInterval(() => {
                if (timer > 0) {
                    timer = timer - 1
                } else {
                    postMessage('expired')
                    clearInterval(timerRef)
                }
            }, 1000);
        }
        
    }
    
}

let code = workerCode.toString();
code = code.substring(code.indexOf("{")+1, code.lastIndexOf("}"));

const blob = new Blob([code], {type: "application/javascript"});
const worker_script = URL.createObjectURL(blob);

export default worker_script;